export interface DramaItem {
  id: string;
  title: string;
  englishTitle: string;
  category: string;
  year: number;
  rating: number;
  episodeCount: number;
  status: '更新中' | '已完结';
  description: string;
  posterSrc: string;
  tags: string[];
  director: string;
  actors: string[];
  region: string;
  updateInfo: string;
  episodes: DramaEpisode[];
}

export interface DramaEpisode {
  ep: number;
  title: string;
  duration: string;
}

export const categories = ['国产剧', '美剧', '韩剧', '日剧', '动漫', '综艺', '纪录片', '港剧'] as const;

export const dramas: DramaItem[] = [
  {
    id: 'drama-1',
    title: '长安十二时辰',
    englishTitle: 'The Longest Day in Chang\'an',
    category: '国产剧',
    year: 2019,
    rating: 8.2,
    episodeCount: 48,
    status: '已完结',
    description: '唐朝天宝三载，上元节前夕，长安城陷入了一场巨大的危机之中。死囚张小敬临危受命，与少年名士李必携手在十二时辰之内，破除隐患，拯救长安。全剧以精密的叙事结构，展现了盛唐时期长安城的人文风貌，以及各色人物在命运洪流中的挣扎与抉择。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20Tang%20Dynasty%20warrior%20in%20dark%20armor%20standing%20in%20ancient%20city%20at%20night%2C%20lanterns%20glowing%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20historical%20epic%20atmosphere%2C%20warm%20golden%20and%20dark%20tones%2C%20movie%20poster%20style&width=600&height=800&seq=drama-changan&orientation=portrait',
    tags: ['古装', '悬疑', '历史'],
    director: '曹盾',
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    region: '中国大陆',
    updateInfo: '全48集已完结',
    episodes: [],
  },
  {
    id: 'drama-2',
    title: '狂飙',
    englishTitle: 'The Knockout',
    category: '国产剧',
    year: 2023,
    rating: 8.5,
    episodeCount: 39,
    status: '已完结',
    description: '讲述了以一线刑警安欣为代表的正义力量，与以高启强为代表的黑恶势力展开的长达二十年的生死较量。通过群像式叙事，展现了扫黑除恶工作的艰辛与复杂，以及普通人在时代浪潮中的命运变迁。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20two%20men%20facing%20each%20other%20in%20tense%20standoff%2C%20dark%20urban%20background%2C%20rainy%20street%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20dramatic%20shadows%2C%20film%20poster%20style%2C%20intense%20mood&width=600&height=800&seq=drama-kuangbiao&orientation=portrait',
    tags: ['犯罪', '剧情', '扫黑'],
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '吴刚'],
    region: '中国大陆',
    updateInfo: '全39集已完结',
    episodes: [],
  },
  {
    id: 'drama-3',
    title: '庆余年',
    englishTitle: 'Joy of Life',
    category: '国产剧',
    year: 2019,
    rating: 7.9,
    episodeCount: 46,
    status: '已完结',
    description: '一个身世神秘的少年范闲，自小跟随奶奶生活在海边小城澹州。在历经家族、江湖、庙堂的种种考验与锤炼之后，他书写了一段光彩夺目的人生传奇。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20young%20man%20in%20elegant%20traditional%20robes%20holding%20sword%2C%20ancient%20palace%20in%20background%2C%20golden%20warm%20lighting%2C%20epic%20cinematic%20composition%2C%20wuxia%20aesthetic%2C%20film%20poster%20style&width=600&height=800&seq=drama-qingyunian&orientation=portrait',
    tags: ['古装', '权谋', '喜剧'],
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    region: '中国大陆',
    updateInfo: '全46集已完结',
    episodes: [],
  },
  {
    id: 'drama-4',
    title: '三体',
    englishTitle: 'Three-Body',
    category: '国产剧',
    year: 2023,
    rating: 8.1,
    episodeCount: 30,
    status: '已完结',
    description: '根据刘慈欣同名科幻小说改编。讲述了地球基础科学研究遭遇异常扰动，纳米科学家汪淼和刑警史强联手调查，揭开了地外文明"三体"世界的神秘面纱，并随之展开了一场全人类共同面对的外星文明入侵故事。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20mysterious%20cosmic%20background%2C%20three%20suns%20in%20the%20sky%2C%20dark%20scientific%20laboratory%20setting%2C%20futuristic%20aesthetic%2C%20cinematic%20sci-fi%20atmosphere%2C%20dramatic%20lighting%2C%20film%20poster%20style&width=600&height=800&seq=drama-santi&orientation=portrait',
    tags: ['科幻', '悬疑', '剧情'],
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    region: '中国大陆',
    updateInfo: '全30集已完结',
    episodes: [],
  },
  {
    id: 'drama-5',
    title: '黑暗荣耀',
    englishTitle: 'The Glory',
    category: '韩剧',
    year: 2023,
    rating: 8.9,
    episodeCount: 16,
    status: '已完结',
    description: '文东恩在高中时期遭受了惨烈的校园暴力后被迫退学，多年后她成为了加害者孩子的班主任，展开了精心策划的复仇计划。一场关于正义与复仇的黑暗故事由此展开。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20elegant%20woman%20in%20dark%20attire%20standing%20in%20front%20of%20a%20school%2C%20dark%20moody%20atmosphere%2C%20revenge%20theme%2C%20cinematic%20lighting%2C%20cold%20color%20tones%2C%20film%20poster%20style&width=600&height=800&seq=drama-theglory&orientation=portrait',
    tags: ['复仇', '剧情', '悬疑'],
    director: '安吉镐',
    actors: ['宋慧乔', '李到晛', '林智妍', '朴成焄'],
    region: '韩国',
    updateInfo: '全16集已完结',
    episodes: [],
  },
  {
    id: 'drama-6',
    title: '鱿鱼游戏',
    englishTitle: 'Squid Game',
    category: '韩剧',
    year: 2021,
    rating: 7.8,
    episodeCount: 9,
    status: '已完结',
    description: '数百名走投无路的人收到神秘邀请，参加一场儿童游戏，但游戏的背后隐藏着致命的秘密。胜者可以获得456亿韩元，败者则付出生命的代价。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%20with%20people%20in%20green%20tracksuits%20standing%20in%20colorful%20playground-like%20staircase%2C%20pink%20guards%2C%20surreal%20atmosphere%2C%20high%20contrast%20colors%2C%20film%20poster%20style&width=600&height=800&seq=drama-squidgame&orientation=portrait',
    tags: ['悬疑', '惊悚', '剧情'],
    director: '黄东赫',
    actors: ['李政宰', '朴海秀', '郑浩妍', '吴永洙'],
    region: '韩国',
    updateInfo: '全9集已完结',
    episodes: [],
  },
  {
    id: 'drama-7',
    title: '人生切割术',
    englishTitle: 'Severance',
    category: '美剧',
    year: 2022,
    rating: 9.0,
    episodeCount: 9,
    status: '已完结',
    description: '一家名为Lumen Industries的公司开发了一种"记忆分割"手术，将员工的工作记忆与个人生活完全分离。马克带领他的团队逐渐发现了这项技术的黑暗真相。',
    posterSrc: 'https://readdy.ai/api/search-image?query=American%20drama%20poster%20with%20office%20worker%20in%20minimalist%20corporate%20hallway%2C%20split%20identity%20concept%2C%20cold%20fluorescent%20lighting%2C%20surreal%20corporate%20aesthetic%2C%20mysterious%20atmosphere%2C%20film%20poster%20style&width=600&height=800&seq=drama-severance&orientation=portrait',
    tags: ['科幻', '悬疑', '惊悚'],
    director: '本·斯蒂勒',
    actors: ['亚当·斯科特', '帕特丽夏·阿奎特', '约翰·特托罗'],
    region: '美国',
    updateInfo: '第一季9集已完结',
    episodes: [],
  },
  {
    id: 'drama-8',
    title: '最后生还者',
    englishTitle: 'The Last of Us',
    category: '美剧',
    year: 2023,
    rating: 9.0,
    episodeCount: 9,
    status: '已完结',
    description: '在真菌感染导致人类文明崩溃的末世中，坚强的走私者乔尔奉命护送14岁的女孩艾莉穿越美国。在这段危机四伏的旅程中，两人之间建立了深厚的情感纽带。',
    posterSrc: 'https://readdy.ai/api/search-image?query=American%20drama%20poster%20with%20rugged%20man%20and%20young%20girl%20walking%20through%20post-apocalyptic%20ruined%20city%2C%20overgrown%20buildings%2C%20warm%20sunset%20lighting%2C%20emotional%20bond%20theme%2C%20film%20poster%20style&width=600&height=800&seq=drama-tlou&orientation=portrait',
    tags: ['末世', '剧情', '冒险'],
    director: '克雷格·麦辛',
    actors: ['佩德罗·帕斯卡', '贝拉·拉姆齐'],
    region: '美国',
    updateInfo: '第一季9集已完结',
    episodes: [],
  },
  {
    id: 'drama-9',
    title: '鬼灭之刃',
    englishTitle: 'Demon Slayer',
    category: '动漫',
    year: 2019,
    rating: 9.1,
    episodeCount: 55,
    status: '更新中',
    description: '大正时期，少年灶门炭治郎一家惨遭鬼的杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复成人的方法，炭治郎踏上了成为鬼杀队剑士的道路。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20young%20samurai%20boy%20holding%20katana%20with%20water%20effects%2C%20dark%20forest%20background%2C%20demons%20lurking%2C%20vibrant%20anime%20art%20style%2C%20cinematic%20composition%2C%20dramatic%20lighting&width=600&height=800&seq=drama-kimetsu&orientation=portrait',
    tags: ['热血', '战斗', '奇幻'],
    director: '外崎春雄',
    actors: ['花江夏树', '鬼头明里', '下野纮'],
    region: '日本',
    updateInfo: '锻刀村篇更新至第11集',
    episodes: [],
  },
  {
    id: 'drama-10',
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    category: '国产剧',
    year: 2023,
    rating: 8.7,
    episodeCount: 30,
    status: '已完结',
    description: '九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上人来人往，饭桌上觥筹交错，一幅生动的上海浮世绘徐徐展开。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20with%20elegant%20man%20in%201990s%20Shanghai%20style%20suit%2C%20neon%20lit%20street%20at%20night%2C%20vintage%20Shanghai%20aesthetic%2C%20warm%20golden%20tones%2C%20nostalgic%20cinematic%20atmosphere%2C%20film%20poster%20style&width=600&height=800&seq=drama-fanhua&orientation=portrait',
    tags: ['都市', '剧情', '年代'],
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    region: '中国大陆',
    updateInfo: '全30集已完结',
    episodes: [],
  },
  {
    id: 'drama-11',
    title: '重启人生',
    englishTitle: 'Brush Up Life',
    category: '日剧',
    year: 2023,
    rating: 9.1,
    episodeCount: 10,
    status: '已完结',
    description: '麻美是一名普通的公务员，在一次意外中去世后发现自己可以重新活一遍人生。为了来世能投胎为人，她不断积累功德，在一次又一次的重启中，重新审视友情、家庭和人生的意义。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20poster%20with%20ordinary%20woman%20in%20everyday%20clothes%20smiling%20warmly%2C%20soft%20pastel%20color%20palette%2C%20whimsical%20atmosphere%2C%20slice%20of%20life%20aesthetic%2C%20gentle%20lighting%2C%20film%20poster%20style&width=600&height=800&seq=drama-brushup&orientation=portrait',
    tags: ['奇幻', '喜剧', '人生'],
    director: '水野格',
    actors: ['安藤樱', '夏帆', '木南晴夏'],
    region: '日本',
    updateInfo: '全10集已完结',
    episodes: [],
  },
  {
    id: 'drama-12',
    title: '信号',
    englishTitle: 'Signal',
    category: '韩剧',
    year: 2016,
    rating: 9.2,
    episodeCount: 16,
    status: '已完结',
    description: '一部老式对讲机连接了身处2015年的犯罪心理侧写师朴海英和2000年的刑警李材韩。两人隔着时空携手侦破多年悬案，改变过去的同时也改变了未来。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20detective%20holding%20old%20walkie-talkie%2C%20time%20travel%20concept%2C%20dark%20crime%20scene%20background%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20film%20poster%20style&width=600&height=800&seq=drama-signal&orientation=portrait',
    tags: ['悬疑', '犯罪', '穿越'],
    director: '金元锡',
    actors: ['李帝勋', '金惠秀', '赵震雄'],
    region: '韩国',
    updateInfo: '全16集已完结',
    episodes: [],
  },
  {
    id: 'drama-13',
    title: '漫长的季节',
    englishTitle: 'The Long Season',
    category: '国产剧',
    year: 2023,
    rating: 9.4,
    episodeCount: 12,
    status: '已完结',
    description: '小城桦林，出租车司机王响遭遇套牌车事件，意外牵扯出十八年前的一桩碎尸悬案。在追寻真相的过程中，三段跨越近二十年的时空交错展开，揭开了一段尘封的往事。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20with%20middle-aged%20taxi%20driver%20in%20northern%20Chinese%20small%20town%2C%20autumn%20leaves%2C%20rusty%20industrial%20background%2C%20nostalgic%20melancholic%20atmosphere%2C%20cinematic%20lighting%2C%20film%20poster%20style&width=600&height=800&seq=drama-longseason&orientation=portrait',
    tags: ['悬疑', '剧情', '年代'],
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊'],
    region: '中国大陆',
    updateInfo: '全12集已完结',
    episodes: [],
  },
  {
    id: 'drama-14',
    title: '怪奇物语',
    englishTitle: 'Stranger Things',
    category: '美剧',
    year: 2016,
    rating: 8.9,
    episodeCount: 34,
    status: '更新中',
    description: '印第安纳州霍金斯小镇，一名小男孩神秘失踪后，他的朋友们、家人和警察局长被卷入了一个涉及秘密实验、超自然力量和另一个维度世界的谜团之中。',
    posterSrc: 'https://readdy.ai/api/search-image?query=American%20drama%20poster%20with%20group%20of%20kids%20on%20bikes%20in%201980s%20suburban%20neighborhood%2C%20red%20sky%20with%20supernatural%20elements%2C%20nostalgic%20retro%20aesthetic%2C%20cinematic%20composition%2C%20film%20poster%20style&width=600&height=800&seq=drama-stranger&orientation=portrait',
    tags: ['科幻', '恐怖', '青春'],
    director: '达菲兄弟',
    actors: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德'],
    region: '美国',
    updateInfo: '第四季更新中',
    episodes: [],
  },
  {
    id: 'drama-15',
    title: '间谍过家家',
    englishTitle: 'Spy x Family',
    category: '动漫',
    year: 2022,
    rating: 9.0,
    episodeCount: 37,
    status: '更新中',
    description: '为了执行秘密任务，顶级间谍"黄昏"组建了一个临时家庭。但他并不知道，妻子是一位职业杀手，而女儿则是一名能读心的超能力者。三人各怀秘密的同居生活就此展开。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20poster%20with%20stylish%20family%20of%20three%20in%20elegant%20attire%2C%20spy%20theme%2C%20vibrant%20colorful%20anime%20art%20style%2C%20fun%20lighthearted%20atmosphere%2C%20cinematic%20composition&width=600&height=800&seq=drama-spyfamily&orientation=portrait',
    tags: ['喜剧', '动作', '日常'],
    director: '古桥一浩',
    actors: ['江口拓也', '种崎敦美', '早见沙织'],
    region: '日本',
    updateInfo: '第二季更新至第12集',
    episodes: [],
  },
  {
    id: 'drama-16',
    title: '非自然死亡',
    englishTitle: 'Unnatural',
    category: '日剧',
    year: 2018,
    rating: 9.3,
    episodeCount: 10,
    status: '已完结',
    description: '三澄美琴是一名在"非自然死亡原因研究所"工作的法医。她和同事们通过对遗体进行解剖，揭开了一个又一个非自然死亡案件背后的真相。',
    posterSrc: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20poster%20with%20female%20forensic%20doctor%20in%20white%20lab%20coat%2C%20autopsy%20room%20background%2C%20medical%20mystery%20theme%2C%20clean%20modern%20aesthetic%2C%20cinematic%20lighting%2C%20film%20poster%20style&width=600&height=800&seq=drama-unnatural&orientation=portrait',
    tags: ['医疗', '悬疑', '剧情'],
    director: '冢原亚由子',
    actors: ['石原里美', '井浦新', '洼田正孝'],
    region: '日本',
    updateInfo: '全10集已完结',
    episodes: [],
  },
];

export const featuredDramas = dramas.filter((d) => d.rating >= 9.0);

export const getDramasByCategory = (category: string) =>
  dramas.filter((d) => d.category === category);

export const getDramaById = (id: string) =>
  dramas.find((d) => d.id === id);

export const getHotDramas = () =>
  [...dramas].sort((a, b) => b.rating - a.rating).slice(0, 8);

export const getLatestDramas = () =>
  [...dramas].filter((d) => d.status === '更新中').slice(0, 8);